module.exports = __webpack_public_path__ + "static/media/GAINZ.3f5e5f7b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/GAINZ.png
// module id = 25
// module chunks = 0